import { styled } from '@mui/material/styles';
import { AdvancedMarker, InfoWindow, Pin, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import theme from '~/theme.js';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

const InfoBoxContent = styled('div')(() => ({
    background: 'grey',
    padding: '1em',
    border: '1px solid grey',
    borderRadius: '8px',
    opacity: 0.9
}));

const Component = props => {
    const {
        tooltip = 'Tooltip information',
        position = { lat: 40.418061, lng: -3.696032 },
        tooltipMutex,
        tooltipID,
        status = 'ok'
    } = props;
    const { handleSetTooltipMutex, onClick } = props;

    // `markerRef` and `marker` are needed to establish the connection between
    // the marker and infowindow (if you're using the Marker component, you
    // can use the `useMarkerRef` hook instead).
    const [markerRef, marker] = useAdvancedMarkerRef();

    const [infoWindowShown, setInfoWindowShown] = useState(false);

    // boxId: PropTypes.number -> Id for the tooltip
    // tooltipMutex: PropTypes.number -> current Id for the tooltip open
    // handleSetTooltipMutex: PropTypes.func, -> handler that controls parent state
    //
    // Allow to control the Tooltip rendering from the outside, only one tooltip
    // should be rendered
    useEffect(() => {
        // Close this InfoWindow if another one was opened
        if (tooltipMutex !== tooltipID) {
            setInfoWindowShown(false);
        }
    }, [tooltipMutex, tooltipID]);

    const handleMouseEnter = useCallback(() => {
        if (tooltipMutex === 0) {
            handleSetTooltipMutex(tooltipID);
            setInfoWindowShown(true);
        } else if (tooltipMutex !== tooltipID) {
            handleSetTooltipMutex(0);
        }
    }, [tooltipMutex, tooltipID, handleSetTooltipMutex]);

    const handleMouseLeave = useCallback(() => {
        if (tooltipMutex === tooltipID) {
            setInfoWindowShown(false);
            handleSetTooltipMutex(0);
        }
    }, [tooltipMutex, tooltipID, handleSetTooltipMutex]);

    const InfoBox = () => {
        if (infoWindowShown) {
            return (
                <InfoWindow
                    anchor={marker}
                    headerDisabled={true}
                >
                    <InfoBoxContent>
                        <div>{tooltip}</div>
                    </InfoBoxContent>
                </InfoWindow>
            );
        }
    };

    return (
        <>
            <AdvancedMarker
                onClick={onClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                position={position}
                ref={markerRef}
            >
                <Pin background={theme.palette.pins[status]} borderColor="#000" glyphColor={theme.palette.pins[status]} scale={0.6}/>
            </AdvancedMarker>
            <InfoBox/>
        </>
    );
};

Component.propTypes = {
    tooltip: PropTypes.element,
    tooltipID: PropTypes.number,
    tooltipMutex: PropTypes.number,
    handleSetTooltipMutex: PropTypes.func,
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired
    }).isRequired,
    status: PropTypes.string,
    classesOverride: PropTypes.shape({
        infoBoxContent: PropTypes.object
    }),
    onClick: PropTypes.func
};

export default Component;
